import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/components/ui/library/card";
import DetailItem from "../../../../features/leads/components/view-lead/components/Overview/components/DetailItem";
import { useEducation } from "../../context/EducationContext";

export default function CourseInfoCard() {
  const { course } = useEducation();

  if (!course) return null;

  return (
    <Card className="border-[#e6e8e7] rounded-[16px] gap-1 py-4 shadow-none">
      <CardHeader className="px-4 pb-0">
        <CardTitle className="text-[16px] font-medium text-black tracking-[-0.32px] leading-normal">
          Course Info
        </CardTitle>
      </CardHeader>
      <CardContent className="px-4 pt-0">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-y-5 gap-x-4 lg:gap-x-8 pl-2">
          <DetailItem label="Course name" value={course?.name} />
          <DetailItem label="University" value={course?.university?.name} />
          <DetailItem
            label="Fees"
            value={
              Number(course?.minFee) > 0
                ? `${course?.minFee} ${course?.university?.currency ?? ""} - Total`
                : "Not specified"
            }
          />
          <DetailItem
            label="Duration"
            value={`${(course?.duration ?? 0) / 12} Years`}
          />
        </div>
      </CardContent>
    </Card>
  );
}
